/**
 * Web configuration.
 *
 * Values come from Vite env vars at build time (see web/.env.example). The
 * defaults point at Robinhood Chain testnet so a fresh clone runs without
 * touching mainnet.
 */

export const CHAINS = {
  mainnet: {
    id: 4663,
    name: "Robinhood Chain",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
      default: { http: ["https://rpc.mainnet.chain.robinhood.com"] },
    },
    blockExplorers: {
      default: {
        name: "Blockscout",
        url: "https://robinhoodchain.blockscout.com",
      },
    },
  },
  testnet: {
    id: 46630,
    name: "Robinhood Chain Testnet",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
      default: { http: ["https://rpc.testnet.chain.robinhood.com"] },
    },
    blockExplorers: {
      default: {
        name: "Blockscout",
        url: "https://explorer.testnet.chain.robinhood.com",
      },
    },
  },
} as const;

const env = import.meta.env;

const network = (env.VITE_HOODSTREET_NETWORK ?? "testnet") as keyof typeof CHAINS;

export const config = {
  chain: CHAINS[network],
  contractAddress: (env.VITE_HOODSTREET_CONTRACT_ADDRESS ??
    "0x0000000000000000000000000000000000000000") as `0x${string}`,
  /** The vault (HoodStreetBank): pays the stake share and the work wages. */
  bankAddress: (env.VITE_HOODSTREET_BANK_ADDRESS ??
    "0x0000000000000000000000000000000000000000") as `0x${string}`,
  apiBase: env.VITE_HOODSTREET_API_BASE ?? "http://localhost:8787",
  collectionSize: 4444,
} as const;

/** EIP-1193 provider injected by the wallet. */
export interface Eip1193Provider {
  request: (args: { method: string; params?: unknown[] }) => Promise<unknown>;
  on?: (event: string, handler: (...args: unknown[]) => void) => void;
}

declare global {
  interface Window {
    ethereum?: Eip1193Provider;
  }
}